import React, { Component } from "react";
import { LayoutContext } from "../../../../modules/ContextModules/LayoutContext";
import { LayerItem } from "./LayerItem/LayerItem";

import './SelectedLayerList.css'

export class SelectedLayerList extends Component {
    static contextType = LayoutContext;
    render() {
        return (
            <div className="selectedLayerList">
                {
                    this.context.selectedLayerContext.layers.map((layer)=>{
                        return (
                            <LayerItem key={layer.Name} data={layer} handleRemove={this.handleRemove}/>
                        );
                    })
                }            
            </div>
        );
    }

    handleRemove = (removeLayers) => {
        this.context
        .selectedLayerContext
        .updateLayers({
            remove:removeLayers
        })
    }
}
    